export const BuildInfo = {timestamp:1774478711000}
